import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {updateIntl} from 'react-intl-redux';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';

const localeConfig = window.LOCALE_CONFIG;

export class LocaleSwitcher extends Component {

   constructor(props) {
      super(props);

      this.handleSelectChange = this.handleSelectChange.bind(this);
   }

   handleSelectChange(e, index, value) {
      const {dispatch} = this.props;
      switch (value){
         case 'ru':
            dispatch(updateIntl(localeConfig.ru));
            break;
         case 'en':
            dispatch(updateIntl(localeConfig.en));
            break;
         default:
            dispatch(updateIntl(localeConfig.en));
            break;
      }
      localStorage.setItem('localeInfo', value);
   }

   render() {
      const {locale} = this.props;
      const btnLabelStyle = {
         color: '#fff'
      };
      return (
         <div style={{marginTop: 7}}>
            <DropDownMenu
               value={locale}
               labelStyle={btnLabelStyle}
               underlineStyle={{display: 'none'}}
               onChange={this.handleSelectChange}>
               <MenuItem value='en' primaryText="Eng" />
               <MenuItem value='ru' primaryText="Рус" />
            </DropDownMenu>
         </div>
      );
   }
}

LocaleSwitcher.propTypes = {
   locale: PropTypes.string
};

function mapStateToProps(state) {
   return {
      locale: state.intl.locale
   }
};

export default connect(mapStateToProps)(LocaleSwitcher);



// WEBPACK FOOTER //
// ./src/components/LocaleSwitcher.js